import Vue from "vue";
import VueRouter from "vue-router";
import LoginView from "../views/login/index.vue";
import i18n from '@/languages' // internationalization

Vue.use(VueRouter);

  import Layout from "@/layout";

export const constantRoutes = [
  {
    path: "/redirect",
    component: () => import("@/layout/index.vue"),
    hidden: true,
    children: [
      {
        path: "/redirect/:path(.*)",
        component: () => import("@/views/redirect/index"),
      },
    ],
  },
  {
    path: "/",
    component: Layout,
    redirect: "/dashboard",
    children: [
      {
        path: "dashboard",


        //  component: () => import('@/views/vmonitor/realmonitor/index'),
        // component: () => import('@/views/vmonitor/speedlimit/index'),src\views\vmonitor\recharge
        //  component: () => import('@/views/vmonitor/VedioMonitor/VedioMonitorMgr'),//视频监控
        //  component: () => import('@/views/vmonitor/recharge'),//充电监控
        //   component: () => import('@/views/vmonitor/VehiclePhotoMgr/VehiclePhotoCapture'),//图片抓拍
        //   component: () => import('@/views/statistics/operationalData/index'),
        // component: () => import('@/views/vmonitor/locateVehicle/index'),//定位监控
        //  component: () => import('@/views/statistics/energyConspt/index'),//能耗统计

        // component: () => import('@/views/vmonitor/locateVehicle/VehicleDashboard'),//仪表盘
        // component: () => import('@/views/statistics/socchange/index'),//soc变化曲线
        // component: () => import('@/views/statistics/oilchart/index'),//油量变化曲线
        // component: () => import('@/views/statistics/oilStatistics/index'),//加油统计
        // component: () => import('@/views/statistics/longOfflineStatistics/index'),//长期停滞统计
        // component: () => import('@/views/statistics/ev_data/whole.vue'),//整车数据
        // component: () => import('@/views/statistics/ev_data/battey.vue'),//电池数据
        // component: () => import('@/views/statistics/ev_data/motor.vue'),//电机数据

        // component: () => import('@/views/statistics/wholeStatistics/index'),//整车数据
        // component: () => import('@/views/statistics/vehicleReport/index'),//单车分析报告
        //  component: () => import('@/views/statistics/vehicleLastData/index'),//车辆最后一条数据

        // component: () => import('@/views/statistics/DriverSignInOutRec/index'),//司机签到签出记录

        // component: () => import('@/views/basicmanagement/organstructure/index'),//组织架构

        // component: () => import('@/views/vmonitor/locateVehicle/components/vehicle_info'),//新版车辆信息
        // component: () => import('@/views/vmonitor/locateVehicle/components/vehicle_monitor_info'),//车辆的故障列表

        // component: () => import('@/views/driver/drivingStatistics/index'),//驾驶评分-首页
        // component: () => import('@/views/driver/vehicleInspection/index'),//巡检
        // component: () => import('@/views/driver/vehicleInspection/inspectionSetting/index'),//巡检设置
        // component: () => import('@/views/driver/drivingStatistics/detail'),//驾驶评分-详细信息

        // component: () => import('@/views/driver/drivingStatistics/detail'),//驾驶评分-雷达图

        // component: () => import('@/views/alarm/alarmdata/index'),//报警统计

        // component: () => import('@/views/vmonitor/ACBooking/index'),//空调预约
        // component: () => import('@/views/statistics/ACStatistics/index'),//空调统计
        // component: () => import('@/views/statistics/motorStatistics/index'),//电机统计
        // component: () => import('@/views/driver/fuel_efficient_driving/fuel_home/index'),//节油驾驶
        // component: () => import('@/views/alarm/alarmdata/index'),//报警统计

        // component: () => import('@/views/alarm/failure/index'),//故障查询


        // component: () => import('@/views/maintenance/annualInspection/index'),//年检登记
        //  component: () => import('@/views/maintenance/insurance/index'),//保险登记
        //  component: () => import('@/views/maintenance/upkeep/index'),//保养登记
        //  component: () => import('@/views/maintenancemanagement/repairregistration/index'),//维修登记
        // component: () => import('@/views/maintenancemanagement/accidentManagement/index'),//事故登记
        // component: () => import('@/views/maintenancemanagement/accidentStatistics/index'),//事故统计
        //  component: () => import('@/views/maintenancemanagement/violationManagement/index'),//违章登记
        //   component: () => import('@/views/maintenancemanagement/violationStatistics/index'),//违章统计

        // component: () => import('@/views/driver/drivingScores/index'),  //驾驶评分
        //    component: () => import('@/views/statistics/chronology/index'),//工作年表-已发布
        //  component: () => import('@/views/statistics/energyConspt/index'),//工作年表-已发布
        //   component: () => import('@/views/basicmanagement/driverManagement/index'), //司机管理
        // component: () => import('@/views/maintenancemanagement/violationManagement/index'),

        //  component: () =>import("@/views/maintenance/transactionReminder/index"), //事务提醒
        //  component: () => import('@/views/demo/recharge'),
        //  component: () => import('@/views/demo/alarmlist'),
        //  component: () => import('@/views/demo/list'),

        // component: () => import('@/components/SingleVehicleMsg'),
        // component: () => import('@/components/SingleVehicleTrack'),


        //  
        // component: () => import('@/views/dashboard/index'),//龙翼简报
        // component: () => import('@/views/statistics/rechargehistory/index'), //充电历史记录
        // component: () => import('@/views/statistics/batteryStatistics/index'),//电池分析图表
        // component: () => import('@/views/statistics/batteryStatistics/history'),//电池历史数据
        // component: () => import('@/views/vmonitor/speedlimit/index.vue'),//限速管理
        // component: () => import('@/components/KLVideo/index'),//视频组件
        // component: () => import('@/views/sysmgr/rolemgr/index'),//角色管理
        //  component: () => import('@/views/basicmanagement/vehicleInfo/index'),//车辆管理
        //  component: () => import('@/views/sysmgr/operatormgr/index'),//操作员管理
        // component: () => import('@/views/statistics/speedcharts/index'),//车速分析图表
        // component: () => import('@/views/statistics/schedule/index'),//行程查询功能
        // component: () => import('@/views/statistics/schedule/detail'),//行程详细功能
        // component: () => import('@/views/driver/fuel_efficient_driving/fuel_home/index'),//节油评分
        //  component: () => import('@/views/demo/map'),//地图测试
        component: () => import('@/views/dashboard/index2025'),//新版首页简报
        // component: () => import('@/views/commuting_management/points/index'),//站点管理

        name: "dashboard",
        meta: { title: "dashboard", icon: "dashboard", affix: true },
      },
    ],
  },
  {
    path: "/inspectiondetail",
    name: "inspectiondetail",
    component: () => import("@/views/driver/vehicleInspection/inspectiondetail"),
  },
  {
    path: "/speedlimit",
    component: () => import("@/layout/index.vue"),

    children: [
      {
        path: "hightlimit",
        component: () => import("@/views/vmonitor/speedlimit/hightlimit"),
        name: "hightlimit",
        meta: { title: "最高车速控制", icon: "hightlimit" },
      },
      {
        path: "arealimit",
        component: () => import("@/views/vmonitor/speedlimit/arealimit"),
        name: "arealimit",
        meta: { title: "区域限速控制", icon: "arealimit" },
      },
      {
        path: "time_speed_set",
        component: () => import("@/views/vmonitor/speedlimit/time_speed_set"),
        name: "time_speed_set",
        meta: { title: "夜间限速设置", icon: "time_speed_set" },
      },
      {
        path: "tired_limit_speed_set",
        component: () =>
          import("@/views/vmonitor/speedlimit/tired_limit_speed_set"),
        name: "tired_limit_speed_set",
        meta: { title: "疲劳驾驶限速设置", icon: "tired_limit_speed_set" },
      },
      {
        path: "hightremind",
        component: () => import("@/views/vmonitor/speedlimit/hightremind"),
        name: "hightremind",
        meta: { title: "最高超速提醒", icon: "hightremind" },
      },
      {
        path: "arealimitremind",
        component: () => import("@/views/vmonitor/speedlimit/arealimitremind"),
        name: "arealimitremind",
        meta: { title: "区域超速提醒", icon: "arealimitremind" },
      },
      {
        path: "PartRoadSpeedlimit",
        component: () =>
          import("@/views/vmonitor/speedlimit/PartRoadSpeedlimit"),
        name: "PartRoadSpeedlimit",
        meta: { title: "分路段超速提醒", icon: "PartRoadSpeedlimit" },
      },
    ],
  },

  // {
  //   path: "/maintenance",
  //   component: () => import("@/layout/index.vue"),

  //   children: [
  //     {
  //       path: "yearlyOrQuarter",
  //       component: () => import("@/views/maintenance/yearlyOrQuarter"),
  //       name: "运营证年检/季检",
  //       meta: { title: "运营证年检/季检", icon: "yearlyOrQuarter" },
  //     },
  //     {
  //       path: "annualInspection",
  //       component: () => import("@/layout/index.vue"),

  //       component: () => import("@/views/maintenance/annualInspection/index"),
  //       name: "年检登记",
  //       meta: { title: "年检登记", icon: "yearlyOrQuarter" },
  //     },
  //     {
  //       path: "insurance",
  //       component: () => import("@/layout/index.vue"),

  //       component: () => import("@/views/maintenance/insurance/index"),
  //       name: "保险登记",
  //       meta: { title: "保险登记", icon: "yearlyOrQuarter" },
  //     },
  //     {
  //       path: "upkeep",
  //       component: () => import("@/layout/index.vue"),

  //       component: () => import("@/views/maintenance/upkeep/index"),
  //       name: "保养登记",
  //       meta: { title: "保养登记", icon: "yearlyOrQuarter" },
  //     },
  //   ],
  // },

  {
    path: "/fuel_efficient_driving",
    // name: "abnormal_detail",
    component: () => import("@/layout/index.vue"),
    children: [
      {
        path: "abnormal_detail",
        component: () => import("@/views/driver/fuel_efficient_driving/abnormal_detail/index"),
        name: "abnormal_detail",
        meta: { title: i18n.t('fuelEfficientDriving.异常驾驶行为'), icon: "abnormal_detail" },
      },
    ],
  },

  {
    path: "/setting",
    component: () => import("@/layout/index.vue"),

    children: [
      {
        path: "changepsw",
        component: () => import("@/views/setting/changepsw/index"),
        name: "changePsw",
        meta: { title: "changepsw", icon: "changepsw" },
      },
      {
        path: "feedback",
        component: () => import("@/views/setting/feedback/index"),
        name: "feedback",
        meta: { title: "feedback", icon: "feedback" },
      },
    ],
  },
  {
    path: "/login",
    name: "login",
    component: LoginView,
  },

];

// const router = new VueRouter({
//   scrollBehavior: () => ({ y: 0 }),
//   mode: 'history',
//   base: process.env.BASE_URL,
//   routes:constantRoutes
// })

const createRouter = () =>
  new VueRouter({
    // mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes,
  });

const router = createRouter();

export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;
